/**
 * Adzuki.Lightbox
 create a modal image gallery
 */

(function Lightbox($, Adzuki)
{
	"use strict";

	var $modal = $('.modal');

	$(document).ready(function documentReady()
	{

		if ($('.lightbox').length > 0) {
			$('.lightbox').click(function visualListClicked(e) {
				var $self              = $(this),
					controller         = $self.data('controller'),
					action             = $self.data('action'),
					id                 = $self.data('id'), // id of whatever you want a photo so(for example testimonial_id)
					current_photo      = $self.data('current_photo_id');// the photo that loads when modal is opened
				e.preventDefault();

				Adzuki.Ajax.get('/' + controller + '/' + action + '/' + id + '/' + current_photo).then(function success(response) {
					$modal.addClass('wide');
					$modal.find('.modal-dialog').addClass('modal-lg');
					$modal.find('.modal-title').text("Photos");
					$modal.find('.modal-body').html(response);

					// load photo based on which photo they clicked on testimonial view
					$('.lightbox-item').each(function findFirstPhoto(x) {
						var photo = ($(this).data('id'));

						if (photo === current_photo) {
							$(this).removeClass('hidden');
						}
					});
					$('.demo').each(function findFirstMenuItem(x) {
						var photo = ($(this).data('name'));

						if (photo === current_photo) {
							$(this).addClass('demo-selected');
						}
					});

					$('.demo').each(function showSlides(n) {
						var length = $('.demo').length;
						// next arrow logic
						$('.lightbox-next').click(function nextSlide(a) {
							var position = $(this).data('id');

							$('.lightbox-item').addClass('hidden');
							$('.demo').removeClass('demo-selected');

							$('.lightbox-item').each(function showNextImage(k) {
								var next_photo = ($(this).data('name'));
								var photo_index = position + 1;

								if (photo_index === length) {
									photo_index = 0;
								}
								if (photo_index === next_photo) {
									$(this).removeClass('hidden');
								}
							});
							$('.demo').each(function moveSlides(n) {
								var demo_array = ($(this).data('id'));
								var photo_index = position + 1;

								if (photo_index === length) {
									photo_index = 0;
								}

								if (demo_array === photo_index) {
									$(this).addClass('demo-selected');
								}
							});

						});
						// previous arrow logic
						$('.lightbox-prev').click(function nextSlide(a) {
							var position = $(this).data('id');

							$('.lightbox-item').addClass('hidden');
							$('.demo').removeClass('demo-selected');

							$('.lightbox-item').each(function showNextImage(k) {
								var next_photo = ($(this).data('name'));
								var photo_index = position - 1;

								if (photo_index === -1) {
									photo_index = length - 1;
								}
								if (photo_index === next_photo) {
									$(this).removeClass('hidden');
								}
							});
							$('.demo').each(function moveSlides(n) {
								var demo_array = ($(this).data('id'));
								var photo_index = position - 1;

								if (photo_index === -1) {
									photo_index = length - 1;
								}
								if (demo_array === photo_index) {
									$(this).addClass('demo-selected');
								}
							});
						});
						// photos clicked on top nav logic
						$(this).click(function hideAllImages(e) {
							var demo_id  = ($(this).data('id'));

							$('.lightbox-item').addClass('hidden');

							$('.lightbox-item').each(function showImage(k) {
								var photo_number = ($(this).data('name'));

								if (demo_id === photo_number) {
									$(this).removeClass('hidden');
								}
							});
						});
						$(this).click(function moveSelector(e) {
							var stuff = ($(this).data('id'));

							$(this).addClass('demo-selected');

							$('.demo').each(function removeSelector(asd) {
								var moreStuff = ($(this).data('id'));

								if (stuff !== moreStuff) {
									$(this).removeClass('demo-selected');
								}
							});
						}); 
					});
					$modal.modal('show');
				});
			});
		}

	});
}(jQuery, window.Adzuki || {}));